import { render, staticRenderFns } from "./CollapseSection.vue?vue&type=template&id=3d2c496e&scoped=true"
import script from "./CollapseSection.vue?vue&type=script&lang=js"
export * from "./CollapseSection.vue?vue&type=script&lang=js"
import style0 from "./CollapseSection.vue?vue&type=style&index=0&id=3d2c496e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2c496e",
  null
  
)

export default component.exports